import React from 'react';
import { useParams } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import { APP_NAME } from '../App';
import Foundation from '../components/prd-workflow/foundationv1';
import useNotification from '../hooks/useNotification';

const PRDWorkflowV1 = () => {
  const { projectId } = useParams();
  const { showNotification } = useNotification();

  return (
    <Box sx={{ width: '100%', bgcolor: '#f5f6f7', px: 3 }}>
      <Box sx={{ mt: 3, px: 4 }}>
        <Typography variant="h5" fontWeight={600}>
          {APP_NAME} - Foundation V1
        </Typography>
      </Box>

      <Box sx={{ pt: 3, pb: 6, px: 4, bgcolor: 'white' }}>
        <Foundation
          projectId={projectId}
          showNotification={showNotification}
        />
      </Box>
    </Box>
  );
};

export default PRDWorkflowV1;
